<style lang="scss">
  .project-selection-wrapper {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>

<script>
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import { projectsStore } from "../../../../../../api-stores/projects-store";
  import { selectedProjectIdsStore } from "../../stores";

  const projectOptions = $derived(
    $projectsStore.map((project) => ({
      id: project.projectId,
      label: project.projectName,
      icon: "far fa-folder",
    }))
  );
</script>

<div class="project-selection-wrapper">
  {#await projectsStore.once()}
    <!-- Delay rendering the actual dropdown until projectOptions is loaded.
     If we render it early, the component initializes with projectOptions = [],
     and since the selected project id is not in the options,
     the <MultiSelectDropdown> will reset selectedItems to []. -->
    <MultiSelectDropdown placeholder="Select projects" disabled={true} />
  {:then _}
    <MultiSelectDropdown
      placeholder="Select projects"
      items={projectOptions}
      bind:selectedItems={$selectedProjectIdsStore}
      dropdownStyle="outline: none; width: 100%;"
      showFilter
    />
  {/await}
</div>
